"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageBirthDateField = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _ManageDateField2 = require("./ManageDateField");
var _DateTime = require("../../utils/DateTime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Extends the ManagedDateField to show a read-only Age field next to it
 * 
*/
var ManageBirthDateField = exports.ManageBirthDateField = /*#__PURE__*/function (_ManageDateField) {
  function ManageBirthDateField() {
    var _this;
    _classCallCheck(this, ManageBirthDateField);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ManageBirthDateField, [].concat(args));
    _defineProperty(_this, "_calcAge", function (val) {
      if (val) {
        try {
          var date = _DateTime.DateUtils.parseDate(val, _this._dateFormat);
          var age = _DateTime.DateUtils.calculateAge(date);
          if (date.getFullYear() <= 1900) age = "--";
          _this.setState({
            age: age
          });
          return;
        } catch (error) {}
      }
      _this.setState({
        age: ""
      });
    });
    return _this;
  }
  _inherits(ManageBirthDateField, _ManageDateField);
  return _createClass(ManageBirthDateField, [{
    key: "set",
    value:
    //Override!
    function set(val) {
      _superPropGet(ManageBirthDateField, "set", this, 3)([val]);
      this._calcAge(val);
    }
  }, {
    key: "accept",
    value: function accept() {
      _superPropGet(ManageBirthDateField, "accept", this, 3)([]);
      this._calcAge(this.state.text);
    }

    //Override - check birthdate is not after current date!
  }, {
    key: "commit",
    value: function commit(text) {
      var _this2 = this;
      try {
        var date;
        date = _DateTime.DateUtils.parseDate(text, this._dateFormat);
        if (date > new Date()) {
          setTimeout(function () {
            return _this2.props.onParseError(_this2.props.label, "Birthdate cannot be after current date");
          }, 1);
          this.reset(); //reset the text field to the original text
          return;
        }
      } catch (error) {} //not a valid date, will be caught in super.commit

      _superPropGet(ManageBirthDateField, "commit", this, 3)([text]);
    }
  }, {
    key: "render",
    value: function render() {
      //Render the calendar buttons surrounded along with the (super's) text field
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '100%',
          display: 'flex',
          alignItems: 'center'
        }
      }, _superPropGet(ManageBirthDateField, "render", this, 3)([]), /*#__PURE__*/_react["default"].createElement(_core.TextField, {
        label: "Age",
        style: _objectSpread(_objectSpread({}, this.props.style), {}, {
          marginLeft: 20,
          maxWidth: 60
        }),
        value: this.state.age,
        fullWidth: false,
        variant: "outlined",
        size: "small",
        inputProps: {
          readOnly: true,
          style: {
            textAlign: 'center'
          }
        },
        InputLabelProps: {
          shrink: true
        }
      }));
    }
  }]);
}(_ManageDateField2.ManageDateField);